import React from 'react'
import { ThemeContext } from 'styles/theme-provider'
import { useLocation } from '@reach/router'
import { LocaleContext } from 'styles/locale-provider'
import { List, Li, Item } from './index.styled'
import Button from 'components/ui-elements/button'
import { navigate } from 'gatsby'

const LegalMenu = () => {
  const { getI18Url, localeText } = React.useContext(LocaleContext)
  const { siteTheme } = React.useContext(ThemeContext)
  return (
    <List>
      <Li className={'first'}>
        <Button
          className={[
            siteTheme === 'header-white' || siteTheme === 'header-black'
              ? 'light-green'
              : 'lightBlue-green',
          ].join(' ')}
          as="button"
          type="button"
          onClick={() => navigate(-1)}
        >
          {localeText['back']}
        </Button>
      </Li>
      <Li>
        <Item to={getI18Url('/legal/#legal')}>TERMS AND CONDITIONS</Item>
      </Li>
      <Li>
        <Item to={getI18Url('/legal/#policy')}>PRIVACY NOTICE</Item>
      </Li>
    </List>
  )
}

export default LegalMenu
